import i18next from 'i18next';
import { APIHelper } from "./APIHelper";
import { ToastifyHelper } from "./ToastifyHelper";

const StringHelper = () => {
    return {
        replaceAll(haystack, needles, replacement) {
            for (let i = 0; i < needles.length; i++) {
                let needle = needles[i];
                let pos = haystack.indexOf(needle);
                while (pos > -1) {
                    haystack = haystack.replace(needle, replacement);
                    pos = haystack.indexOf(needle);
                }
            }
            return haystack;
        },

        isBlank(string) {
            return !string || string.trim().length === 0;
        },

        containsAny(source, lookups, minLength = 3) {
            if (source == null || source.trim() === "" || lookups.length === 0)
                return false;

            for (let i = 0; i < lookups.length; i++) {
                let l = lookups[i];
                if (l.trim().length >= minLength) {
                    if (source.toUpperCase().includes(l.trim().toUpperCase()))
                        return true;
                }
            }
            return false;
        },

        getWithCommaAtTheEnd(value) {
            if (value && value.trim() !== '') {
                return value.slice(-1) === ',' ? value : `${value},`;
            }
            return null;
        },

        copyToClipboard(value, showToast = true) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(value)
                    .then(() => {
                        if (showToast) {
                            ToastifyHelper.info(i18next.t('TextoCopiadoSucesso'));
                        }
                    })
                    .catch((err) => {
                        APIHelper.tratarErro(err);
                    });
                return;
            }

            const el = document.createElement('textarea');
            el.value = value;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            if (showToast) {
                ToastifyHelper.info(i18next.t('TextoCopiadoSucesso'));
            }
        },

        sanitizeText(text) {
            if (!text || typeof text !== 'string') return '';

            let sanitizedText = text.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
            sanitizedText = sanitizedText
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');

            return sanitizedText;
        }
    };
};

export default StringHelper();